import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  InfoBox,
  ErrorBox,
  SuccessBox,
  LoadingSpinner,
  FileInput,
  FileUploadZone,
  ButtonGroup,
  Button,
} from '../PriceListsPage.style';

const XlsxImportModal = ({
  isOpen,
  onClose,
  data,
  onFileSelect,
  onFileDrop,
  onConfirmImport,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <Modal>
      <div onClick={onClose} style={{ position: 'absolute', inset: 0 }} />
      <ModalContent style={{ maxWidth: '600px' }}>
        <ModalHeader>
          <ModalTitle>{t('importPriceListFromXlsx')}</ModalTitle>
        </ModalHeader>

        {data.success ? (
          <SuccessBox>
            <i className="mdi mdi-check-circle" />
            <p>{t('successfullyImportedPricelist')}</p>
          </SuccessBox>
        ) : (
          <>
            <InfoBox>
              <h3>{t('xlsxFileFormat')}</h3>
              <p>{t('xlsxFormatDescription')}</p>
              <p>
                <strong>{t('xlsxSheetNames')}:</strong> {t('brandColumnInfo')}
              </p>
              <p>{t('xlsxDataStartRow')}</p>
              <p>
                <strong>{t('xlsxMustContainColumns')}</strong>
              </p>
              <p style={{ fontSize: '0.85em', color: '#666' }}>
                {t('xlsxColumnDescriptions')}
              </p>
            </InfoBox>

            {data.error && (
              <ErrorBox>
                <i className="mdi mdi-alert-circle" />
                <div>
                  <p>{t('error')}: {data.error}</p>
                </div>
              </ErrorBox>
            )}

            {data.uploading ? (
              <LoadingSpinner>
                <i className="mdi mdi-loading" />
                <span>{t('uploadingFile')}</span>
              </LoadingSpinner>
            ) : (
              <>
                <FileInput
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={onFileSelect}
                  id="xlsx-file-input"
                />
                <label htmlFor="xlsx-file-input">
                  <FileUploadZone
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={onFileDrop}
                    $hasFile={!!data.file}
                  >
                    <i className="mdi mdi-file-upload-outline" />
                    <strong>{t('clickToSelectOrDragXlsx')}</strong>
                    <p>{t('onlyXlsxSupported')}</p>
                    {data.fileName && <p><strong>{t('selectedFile')} {data.fileName}</strong></p>}
                  </FileUploadZone>
                </label>

                <ButtonGroup>
                  <Button type="button" onClick={onClose}>
                    {t('cancel')}
                  </Button>
                  {data.file && (
                    <Button type="button" $primary onClick={onConfirmImport}>
                      {t('uploadAndImport')}
                    </Button>
                  )}
                </ButtonGroup>
              </>
            )}
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default XlsxImportModal;
